import React from 'react';
import PropTypes from 'prop-types';

import Heading from 'common/components/Heading';
import Text from 'common/components/Text';
import Button from 'common/components/Button';
import Icon from 'common/components/Icon';

import styles from './index.module.css';

const NoOffRampsYet = ({
  kybNotSubmitted,
  kybVerifying,
  onCreateOffRamp,
  onVerifyBusiness,
  isSandboxMode,
}) => (
  <div className={styles.root}>
    <div className={styles.content}>
      <div className={styles.message}>
        <Heading size="2" level="2" color="blue">
          {(kybNotSubmitted || kybVerifying) && !isSandboxMode
            ? 'Off ramps not enabled yet'
            : 'No off ramps yet'}
        </Heading>
        <Text>
          {(kybNotSubmitted || kybVerifying) && !isSandboxMode
            ? 'To enable off ramps we need to verify your business'
            : 'Ready to complete your first?'}
        </Text>
      </div>
      <div className={styles.buttonWrapper}>
        <Button
          disabled={kybVerifying && !isSandboxMode}
          full
          icon={
            kybNotSubmitted ? null : (
              <Icon.Plus description="Dollar circle" size="medium" />
            )
          }
          kind="primary"
          onClick={
            kybNotSubmitted && !isSandboxMode
              ? onVerifyBusiness
              : onCreateOffRamp
          }
        >
          <button type="button">
            {kybNotSubmitted && !isSandboxMode
              ? 'Verify my business'
              : 'New off ramp'}
          </button>
        </Button>
      </div>
    </div>
  </div>
);

NoOffRampsYet.propTypes = {
  kybNotSubmitted: PropTypes.bool,
  kybVerifying: PropTypes.bool,
  onCreateOffRamp: PropTypes.func,
  onVerifyBusiness: PropTypes.func,
  isSandboxMode: PropTypes.bool,
};

export default NoOffRampsYet;
